import React from 'react';

import Modal from 'components/commons/modal/Modal';
import Button from 'components/commons/button/Button';

type ReachGroupLimitModalProps = {
  isShow: boolean;
  close: () => void;
};

const ReachGroupLimitModal: React.FC<ReachGroupLimitModalProps> = props => {
  const title = 'グループの数が上限に達しています。';
  const content =
    '登録されているグループの数が上限数(10件)に達しています。新しくグループを作成する場合は既存のグループの削除が必要になります。';
  return (
    <Modal isShow={props.isShow} close={props.close}>
      <div className="ui-effect-fade-in-300 modal-advice">
        <div className="flex pt-3 px-3 justify-end modal-header">
          <div className="flex-grow flex justify-center items-center">
            <div className="modal-header-title">{title}</div>
          </div>
          <button>
            <i
              className="icon-close text-2xl text-gray-500 text-center cursor-pointer"
              onClick={props.close}></i>
          </button>
        </div>
        <div className="modal-advice-body">
          <div className="modal-primary-note">{content}</div>
          <div className="btn-vertical-col">
            <Button fluid text onClick={props.close}>
              閉じる
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReachGroupLimitModal;
